'use client'
import React, { useContext, useEffect, useState } from 'react';
import { Flex } from '@chakra-ui/layout';
import ExperiencesInProductList from '@/products/[id]/components/experiencesInProductList';
import ProductAside from './components/productAside';
import ProductProvider from '../lib/productProvider';
import ProductMembers from './components/productMembers';
import ProductValueProposition from './components/productValueProposition';
import ProductPageProvider from './lib/productPageProvider';
import { useParams } from 'react-router-dom';
import LoadingProduct from './LoadingProduct';
import useProductsApi from '../lib/useProductsApi';
import { AuthContext } from '../../auth/lib/authContext';
export default function ProductDetailPage() {
  const [loadingProduct, setLoadingProduct] = useState(true);
  const [productId, setProductId] = useState(null);
  const [readyToGetId, setReadyToGetId] = useState(null);
  const productApi = useProductsApi();
  const { profile } = useContext(AuthContext);
  const [marked, setMarked] = useState(false);
  const params = useParams();
  useEffect(() => {
  if(productId && profile.id && !marked) {
    setMarked(true);
    productApi.markAsOpened(productId, profile.id)
  }
  }, [productId, marked, profile.id])
  useEffect(() => {
    if (readyToGetId && params.id !== productId) {
      setProductId(params.id)
      setReadyToGetId(false);
    }
  }, [readyToGetId]);
  useEffect(() => {
    if (params.id && params.id !== productId) {
      setReadyToGetId(true);
    }
  }, [params.id]);
  return (
    <>
      {productId && (
        <>
          {loadingProduct && (
            <LoadingProduct />
          )}
          <ProductProvider
            productId={productId}
            onInit={() => {
              setLoadingProduct(false);
            }}
          >
            <ProductPageProvider>
              {!loadingProduct && (
                <Flex
                  flex="1"
                  flexDirection="row"
                  alignItems={"stretch"}
                  overflow={"auto"}
                >
                  <ProductAside />
                  <Flex
                    flex="1"
                    flexDirection={"column"}
                    overflow={"auto"}
                  >
                    <Flex
                      px={3}
                      py={2}
                      bg="white"
                      borderBottom="1px solid"
                      borderColor="divider.grey"
                      justifyContent="flex-end"
                    >
                      <ProductMembers />
                    </Flex>
                    <Flex
                      flex="1"
                      overflow={"auto"}
                      flexDirection={'column'}
                    >
                      <Flex
                       flexDirection={'column'}
                       width={"100%"}
                      >
                        <ProductValueProposition />
                      </Flex>
                      <ExperiencesInProductList
                        emptyHeight={"300px"}
                      />
                    </Flex>
                  </Flex>
                </Flex>
              )}
            </ProductPageProvider>
          </ProductProvider>
        </>)}
    </>
  )
}
